import { h, Component } from 'preact';
import Video from 'components/core/video/video';
import Store from 'store/store';
import * as actions from 'store/actions';
import s from 'components/shared/background/background.sss';
// import pure from 'utils/pure';
// import { getCopyWithParams } from 'utils/clientUtils';
import { accessNested, condClass } from 'utils/utils';
import { useDynamicAssetFolder } from 'utils/assets';

// Find the first non-undefined and non-null value (equivalent to v1 || v2 || v3 ... except returns the value if it's not null/undefined, even if falsy like 0, '' or false)
// TODO: utils
function customDefault() {
	return [].find.call(arguments, v => v != undefined);
}


// @pure
export default class Background extends Component {
	constructor(props) {
		super(props);
		this.canplayEventListener = this.canplayEventListener.bind(this);
		this.errorEventListener = this.errorEventListener.bind(this);

		this.onPlay = this.onPlay.bind(this);
		this.onPause = this.onPause.bind(this);
	}

	shouldComponentUpdate(nextProps) {

		if (this.getActivePath(nextProps) !== this.getActivePath(this.props)) {
			return true;
		}

		if (accessNested(nextProps, 'bgState.muted') !== accessNested(this.props, 'bgState.muted')) {
			return true;
		}

		return false;
	}

	getActivePath(props) {
		// NOTE This is not for rendering purposes.
		// Get the path of either the active video, active image, or the background color to see if this component needs to be re-rendered.
		const pageData = props.appData.pages[props.pageId].data || {};
		const solidColor = customDefault(pageData.useSolidBgColor, accessNested(props, 'bgData.useSolidBgColor', false));
		const img = this.getImageSrc(props);
		const currentVideoSrc = this.getVideoSrc(props);

		//First priority check to see if there is a color value.
		if (solidColor) {
			return true;
		}

		//If current Video src exists, append the img source to the end of it. This will allow us to check if the poster image has been changed.
		if (currentVideoSrc && props.bgState.videoEnabled) {
			return currentVideoSrc + img;
		}

		if (img) {
			return img;
		}
	}

	componentDidMount() {
		this.updateBgElem();
	}

	componentDidUpdate() {
		this.updateBgElem();
	}

	componentWillUnmount() {
		if (this.bg) {
			this.bg.removeEventListener('canplay', this.canplayEventListener);
			this.bg.removeEventListener('error', this.errorEventListener);
		}
	}

	canplayEventListener() {
		if (!this.bg) return;
		this.updateBgElemId(this.bg.id);
	}

	errorEventListener() {
		if (this.base) {
			Store.emit(actions.SET_BACKGROUND_ELEMENT, this.base.id);
		}
	}

	updateBgElemId(id) {
		if (this.props.bgState.element) {
			if (this.props.bgState.element !== id) {
				Store.emit(actions.SET_BACKGROUND_ELEMENT, id);
			}
		} else if (this.$video) {
			this.bg = this.$video.getRef();
			Store.emit(actions.SET_BACKGROUND_ELEMENT, this.bg.id);
		}
	}

	getStyle() {
		return {};
	}

	getVideoSrc(props) {
		const assets = props.appData.urls || {};
		let data = Object.assign({
			videoSrc: assets.bgVideo,
			tabletLandscapeVideoSrc: assets.tabletLandscapeBgVideo,
			tabletVideoSrc: assets.tabletBgVideo,
			mobileLandscapeVideoSrc: assets.mobileLandscapeBgVideo,
			mobileVideoSrc: assets.mobileBgVideo || assets.bgVideo

		}, props.bgData, props.pageBgData);

		if (data.noVideo) {
			return;
		}
		let client = props.client || {};
		let device = client.device;
		let size = client.deviceSize;
		let orientation = client.orientation;

		// Keep this to device as this has always been the default behaviour for a while
		// (request from the producers to keep it that way) - if we want to change please add a toggle in thundr
		if (device === 'desktop') {
			return data.videoSrc;
		}

		let isTablet = device === 'ipad' || (device === 'android' && size !== 'mobile');

		// ipad pro
		// Please use tabletVideoSrc or mobileVideoSrc if you want videos on other devices
		// if (device === 'ipad' && size === 'desktop') {
		// 	return data.videoSrc;
		// }

		// If it's a tablet and a tabletSrc is specified, use it
		if (isTablet) {
			if (data.noVideoOnTablet) {
				return;
			} else if (orientation === 'landscape' && data.tabletLandscapeVideoSrc !== undefined) {
				return data.tabletLandscapeVideoSrc;
			} else if (data.tabletVideoSrc !== undefined) {
				return data.tabletVideoSrc;
			}
		}
		// Otherwise use the mobile src
		if (orientation === 'landscape' && data.mobileLandscapeVideoSrc !== undefined) {
			return data.mobileLandscapeVideoSrc;
		}
		return data.mobileVideoSrc;
	}

	getImageSrc(props) {
		const image = accessNested(props, 'pageBgData.image') || accessNested(props, 'bgData.image');

		if (!image) return;
		if (typeof image === 'string') {
			return useDynamicAssetFolder(image);
		}

		const client = props.client;

		// option 1 : to set a background image you can set a image with the path of the bg image as a string
		// option 2 : you can also make the image an object which has sub objects, the keys of the objects don't matter
		//  which can have the following keys
		// {
		//	src: (the source of the image)
		//  device: (which device it applies to mobile, tablet, desktop)
		//  deviceSize: (same as device but will take device size instead of size)
		//  orientation: (takes in orientation of device)
		// }

		const contexts = Object.values(image).filter(e => e).map(e => {
			if (typeof e === 'string') return { src: e, order: Infinity };
			return e;
		}).sort((a, b) => {
			if (a.order == b.order) return 0;
			return (a.order || 0) - (b.order || 0);
		});
		const mobiles = ['iphone', 'android'];
		const tablets = ['ipad', 'android'];
		const context = contexts.find(context => {
			if (!context.src && !context.noImage) return false;
			if (context.device) {
				let devices = context.device.split(',').map(e => e.trim()).filter(e => e);
				let correct = devices.find(device => {
					if (device === 'mobile') {
						let isMobile = client.deviceSize === 'mobile' || mobiles.indexOf(client.device) !== -1;
						if (isMobile) return true;
					}
					if (device === 'tablet') {
						let isTablet = client.deviceSize !== 'mobile' && tablets.indexOf(client.device) !== -1;
						if (isTablet) return true;
					}
					return client.device === device;
				});
				if (!correct) return false;
			}
			if (context.deviceSize) {
				let sizes = context.deviceSize.split(',').map(e => e.trim()).filter(e => e);
				let correct = sizes.find(size => client.deviceSize === size);
				if (!correct) return false;
			}
			if (context.orientation && client.orientation !== context.orientation) return false;
			return true;
		});
		if (context) {
			return useDynamicAssetFolder(context.src) || '//:0';
		}

		return undefined;
	}

	// Puts the current background in the store for the transparent topbar
	updateBgElem() {
		if (this.$video) {
			let ref = this.$video.getRef();
			if (!ref || ref === this.bg) return;
			if (this.bg) {
				this.bg.removeEventListener('canplay', this.canplayEventListener);
				this.bg.removeEventListener('error', this.errorEventListener);
			}

			this.bg = ref;
			if (this.bg.readyState >= 2) { // HAVE_CURRENT_DATA
				Store.emit(actions.SET_BACKGROUND_ELEMENT, this.bg.id);
			} else {
				this.bg.addEventListener('canplay', this.canplayEventListener);
				this.bg.addEventListener('error', this.errorEventListener);
			}
		} else {
			Store.emit(actions.SET_BACKGROUND_ELEMENT, this.base && this.base.id);
		}
	}

	onPlay() {
		Store.emit(actions.SET_BACKGROUND_VIDEO_PLAYING, true);
	}

	onPause() {
		Store.emit(actions.SET_BACKGROUND_VIDEO_PLAYING, false);
	}

	render(props, state) {
		const {
			appData,
			client,
			bgState,
			bgData = {},
			pageBgData = {},
			pageId,
			iosFixedFix
		} = props;

		const { LoopVideoBG = true } = appData.background;

		const {
			className = ''
		} = state;

		const { isIOS, iOSVersion } = client;

		const activePageData = accessNested(appData, ['pages', pageId, 'data']) || {};

		// TODO: finalBgData = Object.assign({}, bgData, pageBgData); ?

		const style = this.getStyle() || {};
		if (iosFixedFix) {
			style.position = 'absolute';
			style.marginTop = iosFixedFix + 'px';
		}

		// NOTE: why not pageBgData.useSolidBgColor ?
		const solidColor = customDefault(/*pageBgData.useSolidBgColor, */activePageData.useSolidBgColor, bgData.useSolidBgColor);

		if (solidColor) {
			return <div id="bgColor" class={s.color} style={style} />;
		}

		const img = this.getImageSrc(props);
		if (img) {
			style.backgroundImage = 'url(' + img + ')';
		}

		const customBg = pageBgData.custom || bgData.custom;
		if (customBg) {
			// Not needed, we already replace %IMAGE_ROOT% etc. in expandAppData
			// style.background = getCopyWithParams(appData.urls.roots, customBg);
			style.background = customBg;
		}

		const currentVideoSrc = this.getVideoSrc(this.props);
		let useVideo = !!currentVideoSrc;

		if (currentVideoSrc && isIOS && iOSVersion >= 10) {
			useVideo = accessNested(activePageData, 'background.useVideoOnMobile') || bgData.useVideoOnMobile;
		}

		const noVideoOnInitialRender = pageBgData.noVideoOnInitialRender || bgData.noVideoOnInitialRender;
		if (noVideoOnInitialRender && typeof window === 'undefined') {
			useVideo = false;
		}

		if (useVideo) {
			let extra;
			// Removing TransparentVideoBackground for now as never used
			// TODO: add it as feature
			// if(pageBgData.alphaVideo) {
			// 	extra = <TransparentVideoBackground videoSrc={pageBgData.alphaVideo} maskOffset={pageBgData.alphaMaskOffset} loopDelay={pageBgData.alphaLoopDelay} />;
			// }
			const muted = bgState.muted !== false;
			let videoElem;
			if (bgState.videoEnabled) {
				videoElem = (
					<Video
						alt={appData.copy.$BG_VIDEO_DESCRIPTION}
						key={currentVideoSrc}
						class={s.video + condClass(className)}
						src={currentVideoSrc}
						preload="auto"
						autoplay={bgState.videoEnabled}
						loop={LoopVideoBG}
						ref={$ref => (this.$video = $ref)}
						muted={muted}
						playsinline
						isPlaying={this.onPlay}
						isPaused={this.onPause}
						isBgVideo
					/>
				);
			}

			return (
				<div
					id="	"
					ref={(ref) => this.$bgVideoImage = ref}
					class={s.image + condClass(bgState.videoEnabled, s.videoEnabled) + condClass(className)}
					style={style}
				>
					{videoElem}
					{extra}
				</div>
			);
		} else {
			return (
				<div
					id="bgImage"
					ref={(ref) => this.$bgImage = ref}
					class={s.image + condClass(className)}
					style={style}
				/>
			);
		}
	}

}
